var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrybe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 43,
    viewBox: "0 0 37 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9144 22.2364L33.1798 34.9116C33.5919 35.6249 34.2273 35.9232 34.9025 35.9232C35.9128 35.9232 36.9628 35.1726 36.9628 33.8976L37 8.54956C37 7.27458 35.9897 6.48672 34.977 6.48672C34.3018 6.48672 33.6291 6.82473 33.2171 7.53803L25.9144 20.176C25.7282 20.4767 25.6512 20.8495 25.6512 21.1875C25.6512 21.5628 25.7257 21.9008 25.9144 22.2364Z",
    fill: "#2FC18C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3883 26.5484L25.691 39.1864C25.8797 39.5244 25.9914 39.8997 25.9914 40.2352C25.9914 41.3238 25.0184 42.2608 23.9311 42.2608C23.5936 42.2608 23.256 42.1862 22.9209 41.9973L1.0127 29.2848C0.300303 28.8722 0.00244141 28.1962 0.00244141 27.56C0.00244141 26.5111 0.789305 25.4598 2.06269 25.4598L16.6309 25.5344C17.3805 25.5344 18.0532 25.9097 18.3908 26.5459",
    fill: "#2FC18C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5912 16.7239H2.02302C0.749632 16.7239 0 15.7124 0 14.6983C0 14.0223 0.300352 13.3488 1.01027 12.9362L22.9557 0.300727C23.2933 0.114326 23.6681 0 24.0056 0C25.0929 0 26.0287 0.936975 26.0287 2.06284C26.0287 2.40084 25.917 2.73885 25.7283 3.07437L18.3511 15.7124C17.9763 16.3511 17.3409 16.7239 16.5912 16.7239",
    fill: "#2FC18C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrybe);
export default __webpack_public_path__ + "static/media/trybe.e5a1f644bcb900cb64949ceac4b57f55.svg";
export { ForwardRef as ReactComponent };